import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import {clear_work_sheet, CREATE_WORK_SHEET, getAllWorkSheets, createWorkSheet} from "../../../redux/work_sheets";
import SelectInput from "../../../components/select";
import Footer from "../../../components/footer";

const WorkSheets = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_work_sheets = useSelector((state) => state.work_sheets_module._get_all_work_sheets);
    const _get_all_user_types = useSelector((state) => state.user_types_module._get_all_user_types);
    const _get_all_periodicities = useSelector((state) => state.periodicities_module._get_all_periodicities);
    const _create_work_sheet = useSelector((state) => state.work_sheets_module._create_work_sheet);

    const [datas, setDatas] = useState([]);
    const [modal, setModal] = useState(false);

    useEffect(() => {
        if (_get_all_work_sheets.data.datos) {
            setDatas(_get_all_work_sheets.data.datos);
        }
    }, [_get_all_work_sheets]);

    const [userTypes, setUserTypes] = useState([]);
    const [periodicities, setPeriodicities] = useState([]);

    useEffect(() => {
        if (_get_all_user_types.data.datos) {
            setUserTypes(_get_all_user_types.data.datos);
        }
    }, [_get_all_user_types]);

    useEffect(() => {
        if (_get_all_periodicities.data.datos) {
            setPeriodicities(_get_all_periodicities.data.datos);
        }
    }, [_get_all_periodicities]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [form, setForm] = useState({
        nombre: "",
        tipo_usuario: "",
        id_tipo_usuario: 0,
        periodicidad: "",
        id_periodicidad: 0,
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_worksheets').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        history.push(`/hoja-trabajo/detalle/${item.id}`);
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    useEffect(() => {
        if (_create_work_sheet.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_work_sheet(CREATE_WORK_SHEET));
            dispatch(getAllWorkSheets(token));
            setIsLoading(false);
            setModal(false);
            history.push(`/hoja-trabajo/detalle/${_create_work_sheet.data.datos.id}`);
        } else if (_create_work_sheet.status !== 0) {
            dispatch(clear_work_sheet(CREATE_WORK_SHEET));
            toast.error(_create_work_sheet.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_work_sheet, dispatch, history, token]);

    const handleChange = (e) => {
        if (e.target.name === "id_tipo_usuario" || e.target.name === "id_periodicidad") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_periodicidad === 0) {
            toast.error("Debe seleccionar la periodicidad", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_tipo_usuario === 0) {
            toast.error("Debe seleccionar el tipo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(createWorkSheet(token, form));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Hojas de trabajos", link: "/hojas-trabajos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_worksheets').length > 0 ?
                                        <Button type="button" text="Crear" theme="calendar" onClick={() => {
                                            setModal(true);
                                            setForm({...form, nombre: '', tipo_usuario: '', id_tipo_usuario: 0});
                                            document.getElementById('id_tipo_usario').selectedIndex = 0;
                                            document.getElementById('id_periodicidad').selectedIndex = 0;
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={datas}
                                        columns={[
                                            {
                                                name: "nombre",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                            {
                                                name: "tipo_usuario",
                                                label: "Tipo",
                                                type: "text",
                                            },
                                            {
                                                name: "fecha_actualizacion",
                                                label: "Última actualización",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmit}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Crear hoja de trabajo</h5>
                        <div className="form-group">
                            <Input
                                label="Nombre"
                                name="nombre"
                                value={form.nombre}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Periodicidad</label>
                            <SelectInput
                                id="id_periodicidad"
                                label="periodicidad"
                                name="id_periodicidad"
                                value={form.id_periodicidad}
                                select={form.periodicidad}
                                onChange={handleChange}
                                options={periodicities ? periodicities.map((item) => ({
                                    name: item.descripcion,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                        <div className="form-group">
                            <label>Tipo</label>
                            <SelectInput
                                id="id_tipo_usario"
                                label="tipo"
                                name="id_tipo_usuario"
                                value={form.id_tipo_usuario}
                                select={form.tipo_usuario}
                                onChange={handleChange}
                                options={userTypes ? userTypes.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-calendar mb-1 button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default WorkSheets;
